export default __webpack_public_path__ + "static/media/BANCOCENTRAL.e20b3e74.svg";